import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import { genericError, genericSuccess } from '@/utils/alerts.service';
import { reorderUpdateDelete } from '@/store/vendorDashboard/modules/reorderUpdateDelete';

export const filters = {
  namespaced: true,
  state: {
    ...reorderUpdateDelete.state,
    mainFilter: '',
    defaultSort: '',
  },

  getters: {
    ...reorderUpdateDelete.getters,

    options(state) {
      return index => {
        if (state.items.length === 0) return [];
        for (let x of state.items) {
          if (x.order === index) {
            return x.filterOptions;
          }
        }
      };
    },

    newOptions(state) {
      return index => {
        if (state.items.length === 0) return [];
        for (let x of state.items) {
          if (x.order === index) {
            return x.filterNewOptions;
          }
        }
      };
    },
    newItemOptions(state) {
      return index => {
        for (let x of state.newItems) {
          if (x.order === index) {
            return x.filterOptions;
          }
        }
      };
    },

    defaults(state) {
      return { mainFilter: state.mainFilter, defaultSort: state.defaultSort };
    },
  },
  mutations: {
    ...reorderUpdateDelete.mutations,

    setFilters(state, data) {
      data.sort((a, b) => {
        return a.order - b.order;
      });
      data.forEach((x, i) => {
        x.order = i;

        x.filterOptions.sort((a, b) => {
          return a.order - b.order;
        });

        x.filterOptions.forEach((y, j) => {
          y.order = j;
        });
      });
      state.items = data;
    },

    // Existing option, in existing filter
    updateOption(state, payload) {
      const { index, optionIndex, key, value } = payload;

      for (let y of state.items) {
        if (y.order === index) {
          for (let x of y.filterOptions) {
            if (x.order === optionIndex) {
              x[key] = value;
              x['update'] = true;
            }
          }

          y['update'] = true;
        }
      }
    },

    markOptionForDelete(state, { index, optionIndex }) {
      for (let y of state.items) {
        if (y.order === index) {
          // eslint-disable-next-line no-unused-vars
          for (let [i, x] of y.filterOptions.entries()) {
            if (x.order === optionIndex) {
              x['order'] = undefined;
              x['delete'] = true;
            }
          }

          for (let z of y.filterOptions) {
            if (z.order > optionIndex) {
              z.order--;
              z['update'] = true;
            }
          }

          y['update'] = true;
        }
      }
    },

    sortOptions(state, index) {
      state.items[index].filterOptions.sort((a, b) => {
        return a.order - b.order;
      });
    },

    sortNewFilters(state) {
      state.newItems.sort((a, b) => {
        return a.order - b.order;
      });
    },

    sortExisitingFilters(state) {
      state.items.sort((a, b) => {
        return a.order - b.order;
      });
    },

    clearOptions(state) {
      state.items.forEach(el => {
        el.filterNewOptions = [];
      });
    },

    //New option in existing filter
    incrementNewOptions(state, { amount, index }) {
      for (let x of state.items) {
        if (x.order === index) {
          x.filterOptions.push({ order: amount, new: true });
        }
      }
    },

    updateNewOption(state, payload) {
      const { index, optionIndex, key, value } = payload;
      for (let y of state.items) {
        if (y.order === index) {
          for (let x of y.filterOptions) {
            if (x.order === optionIndex) {
              x[key] = value;
            }
          }
          y['update'] = true;
        }
      }
    },

    deleteNewOption(state, { index, optionIndex }) {
      for (let z of state.items) {
        if (z.order === index) {
          for (let [i, x] of z.filterOptions.entries()) {
            if (x.order === optionIndex) {
              z.filterOptions.splice(i, 1);
            }
          }

          for (let y of z.filterOptions) {
            if (y.order > optionIndex) {
              y.order--;
            }
          }
        }
      }
    },

    //New options of a new filter
    incrementNewFilterOptions(state, { amount, index }) {
      for (let x of state.newItems) {
        if (x.order === index) {
          x.filterOptions.push({ order: amount, new: true });
        }
      }
    },

    updateNewFilterOption(state, payload) {
      const { index, optionIndex, key, value } = payload;
      for (let x of state.newItems) {
        if (x.order === index) {
          for (let y of x.filterOptions) {
            if (y.order === optionIndex) {
              y[key] = value;
            }
          }

          x.filterOptions.sort((a, b) => a.order - b.order);
        }
      }
    },

    updateNewFilterOptionOrder(state, payload) {
      const { index, optionIndex, key, value } = payload;
      for (let x of state.newItems) {
        if (x.order === index) {
          x.filterOptions[optionIndex][key] = value;
        }
      }
    },

    sortNewFilterOptions(state, index) {
      for (let x of state.newItems) {
        if (x.order === index) {
          x.filterOptions.sort((a, b) => a.order - b.order);
        }
      }
    },

    updateFilterOption(state, payload) {
      const { index, optionIndex, key, value } = payload.itemData;
      state.items[index].filterOptions[optionIndex][key] = value;

      if (!state.items[index].filterOptions[optionIndex]['new']) {
        state.items[index].filterOptions[optionIndex]['update'] = true;
      }

      state.items[index]['update'] = true;

      if (payload.sort) {
        state.items[index].filterOptions.sort((a, b) => {
          if (!a.order && a.order !== 0) return -1;
          if (!b.order && b.order !== 0) return 1;
          if (!a && !b) return 0;
          return a.order - b.order;
        });
      }
    },

    deleteNewFilterOption(state, { index, optionIndex }) {
      for (let x of state.newItems) {
        if (x.order === index) {
          x.filterOptions.splice(optionIndex, 1);

          for (let y of x.filterOptions) {
            if (y.order > optionIndex) {
              y.order--;
            }
          }
        }
      }
    },

    incrementNewItems(state, order) {
      let filterOptions = [];
      state.newItems.push({ order, filterOptions, new: true });
    },

    setMainFilter(state, id) {
      return (state.mainFilter = id);
    },

    setDefaultSort(state, name) {
      return (state.defaultSort = name);
    },
  },
  actions: {
    ...reorderUpdateDelete.actions,

    addDirtyTab({ commit }) {
      commit('settings/addDirtyTab', 'filters', { root: true });
    },

    async fetchFilters({ dispatch, commit }) {
      return vendorDashboardAPI
        .getFilters()
        .then(data => {
          const { results } = data;
          results.forEach(element => {
            element.filterNewOptions = [];
          });
          commit('setFilters', results);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async saveFilters({ state, commit, dispatch }) {
      const data = [...state.items, ...state.newItems];

      for (let filter of data) {
        for (let i of filter.filterOptions) {
          if (!i.name) {
            return dispatch(
              'showUserMessage',
              {
                success: false,
                title: 'Oops!',
                message: 'Please make sure all filters have a name.',
              },
              { root: true }
            );
          }
        }
      }

      return vendorDashboardAPI
        .saveFilters(data)
        .then(res => {
          res.data.forEach(el => (el.filterNewOptions = []));
          commit('setFilters', res.data);
          commit('clearItems');
          dispatch('showUserMessage', { ...genericSuccess }, { root: true });
          // ??? this was getting returned in previous API service, double check this later
          return data.data;
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    // Since each item of the filters state will have unique option items, i need to
    // handle everything inside the filters store, adding each item their own newOptions, and handling every
    // method action particullary.
    // I tried creating a filterOptions store, but ended up with the options being shared between filters, this is
    // the only way i could come up with to group them.
    // Also, the new filter items need dedicated handling of options. I know this might be very repetitive and messy, but
    // i think we can come back later to improve how this is done. I just want to see it working now haha, and figure out a way to
    // get it done.

    //existing options in existing filters
    updateOption({ commit, dispatch }, payload) {
      commit('updateOption', payload);
      dispatch('addDirtyTab');
    },

    removeOption({ commit, dispatch }, { index, optionIndex }) {
      commit('markOptionForDelete', { index, optionIndex });
      dispatch('addDirtyTab');
    },

    //New options in existing filters
    addNewOption({ commit }, { amount, index }) {
      commit('incrementNewOptions', { amount, index });
    },

    updateNewOption({ commit, dispatch }, payload) {
      commit('updateNewOption', payload);
      dispatch('addDirtyTab');
    },

    removeNewOption({ commit }, { index, optionIndex }) {
      commit('deleteNewOption', { index, optionIndex });
    },

    //Options in New Filter item.
    addNewFilterOption({ commit }, { amount, index }) {
      commit('incrementNewFilterOptions', { amount, index });
    },

    updateNewFilterOption({ commit }, payload) {
      commit('updateNewFilterOption', payload);
    },

    removeNewFilterOption({ commit }, { index, optionIndex }) {
      commit('deleteNewFilterOption', { index, optionIndex });
    },

    //generic methods (i think so...)
    // in the future, i think incrementing/decrementing the order value (++/--)
    // would be a lot simpler, but that is for later
    changeOptionOrder({ commit, dispatch, state }, payload) {
      let clicked;
      let alter;

      const clickedValue = payload.optionIndex + payload.direction;

      for (let [i, x] of state.items[payload.index].filterOptions.entries()) {
        if (x.order === payload.optionIndex) {
          clicked = {
            optionIndex: i,
            value: clickedValue,
            index: payload.index,
            key: 'order',
          };
        }
      }

      for (let [i, x] of state.items[payload.index].filterOptions.entries()) {
        if (x.order === payload.optionIndex + payload.direction) {
          alter = {
            optionIndex: i,
            value: payload.optionIndex,
            index: payload.index,
            key: 'order',
          };
        }
      }

      commit('updateFilterOption', { itemData: clicked, sort: false });
      commit('updateFilterOption', { itemData: alter, sort: true });
      dispatch('addDirtyTab');
    },

    changeOrderOfNewFilterOptionHandler({ commit, state }, payload) {
      let clicked;
      let alter;

      const clickedValue = payload.optionIndex + payload.direction;

      for (let x of state.newItems) {
        if (x.order === payload.index) {
          for (let [i, y] of x.filterOptions.entries()) {
            if (y.order === payload.optionIndex) {
              clicked = {
                optionIndex: i,
                value: clickedValue,
                index: payload.index,
                key: 'order',
              };
            }

            if (y.order === payload.optionIndex + payload.direction) {
              alter = {
                optionIndex: i,
                value: payload.optionIndex,
                index: payload.index,
                key: 'order',
              };
            }
          }
        }
      }

      commit('updateNewFilterOptionOrder', clicked);
      commit('updateNewFilterOptionOrder', alter);
      commit('sortNewFilterOptions', payload.index);
    },

    changeFilterOrder({ commit, dispatch, state }, payload) {
      let clicked;
      let alter;

      const clickedValue = payload.index + payload.direction;

      for (let [i, x] of state.newItems.entries()) {
        if (x.order === payload.index) {
          clicked = { new: true, i, value: clickedValue };
        }
      }

      for (let [i, x] of state.items.entries()) {
        if (x.order === payload.index) {
          clicked = { new: false, i, value: clickedValue };
        }
      }

      for (let [i, x] of state.newItems.entries()) {
        if (x.order === payload.index + payload.direction) {
          alter = { new: true, i, value: payload.index };
        }
      }

      for (let [i, x] of state.items.entries()) {
        if (x.order === payload.index + payload.direction) {
          alter = { new: false, i, value: payload.index };
        }
      }

      if (clicked.new) {
        commit('updateNewItemOrder', clicked);
      } else {
        commit('updateItemOrder', clicked);
      }

      if (alter.new) {
        commit('updateNewItemOrder', alter);
      } else {
        commit('updateItemOrder', alter);
      }

      commit('sortNewFilters');
      commit('sortExisitingFilters');
      dispatch('addDirtyTab');
    },

    clearOptions({ commit }) {
      commit('clearOptions');
    },

    ////////////////////////////////////////
    /// Actions for main sort and filter ///
    ////////////////////////////////////////
    async fetchDefaults({ dispatch, commit }) {
      return vendorDashboardAPI
        .getDetails()
        .then(data => {
          commit('setMainFilter', data.filterAtCard);
          commit('setDefaultSort', data.sortOptions);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async saveDefaults({ dispatch, commit, state }) {
      const data = {
        filterAtCard: state.mainFilter,
        sortOptions: state.defaultSort,
      };
      return vendorDashboardAPI
        .updateDirectoryDetails(data)
        .then(res => {
          commit('setMainFilter', res.data.filterAtCard);
          commit('setDefaultSort', res.data.sortOptions);
          dispatch('showUserMessage', { ...genericSuccess }, { root: true });
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    updateMainFilter({ dispatch, commit }, id) {
      commit('setMainFilter', id);
      dispatch('markDefaultsDirty');
    },

    updateDefaultSort({ dispatch, commit }, name) {
      commit('setDefaultSort', name);
      dispatch('markDefaultsDirty');
    },

    markDefaultsDirty({ commit }) {
      commit('settings/addDirtyTab', 'defaults', { root: true });
    },
  },
};
